import 'antd/dist/antd.css';
import '../styles/globals.css';
import '../styles/login.css';
import '../styles/main.css';
import '../styles/dashboard.css';
import NoSSRWrapper from "../components/no-ssr-wrapper";
import { SessionProvider } from "next-auth/react"
import { ThemeProvider } from 'next-themes'
import Head from 'next/head';
import ToggleableDiv from '../components/ToggleableDiv'
import CookieConsentBanner from "../components/CookieConsentBanner";
import JobsLayout from '../components/JobsLayout';
import AdminLayout from '../components/AdminLayout';
import { useRouter } from 'next/router';
import '../components/axiosSetup';
import '../components/fetchPatch';
import setupAjax from '../components/ajaxSetup';
import { useEffect, useRef } from 'react';
import { LoaderProvider } from '../components/LoaderContext';
import GlobalLoader from '../components/GlobalLoader';
import { loader } from '../components/LoaderBridge';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();
import GenericLayout from '../components/GenericLayout';
function MyApp({ Component, pageProps: { session, ...pageProps }, }) {
  const router = useRouter();
  const isMounted = useRef(true);
  useEffect(() => {
    setupAjax();
    isMounted.current = true;

    const handleStart = () => {
      if (isMounted.current) loader.start();
    }
    const handleStop = () => {
      if (isMounted.current) loader.stop();
    }

    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleStop);
    router.events.on('routeChangeError', handleStop);

    return () => {
      isMounted.current = false;
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleStop);
      router.events.off('routeChangeError', handleStop);
    };
  }, [router]);
  const path = router.pathname;
  let PageWithLayout;

  const moduleName = path.split("/")[1];

  const noLayoutRoutes = ["", "login", "azure-signin", "credentials-signin", "course"];

  if (noLayoutRoutes.includes(moduleName)) {
    PageWithLayout = <Component {...pageProps} />;
  } else {
    PageWithLayout = (
      <GenericLayout url={`/${moduleName}`}>
        <Component {...pageProps} />
      </GenericLayout>
    );
  }

  return (

    <SessionProvider session={session}>
      <ThemeProvider enableSystem={false}>
        <QueryClientProvider client={queryClient}>
          <NoSSRWrapper>

            <ToggleableDiv>
              <Head>
                <title>LMS Portal</title>
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css" crossOrigin="anonymous" referrerPolicy="no-referrer" />
              </Head>
              <LoaderProvider>
                <GlobalLoader />
                {PageWithLayout}
              </LoaderProvider>
              <CookieConsentBanner />
            </ToggleableDiv>
          </NoSSRWrapper>
        </QueryClientProvider>
      </ThemeProvider>
    </SessionProvider>
  )
}

export default MyApp
